import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { RouterProvider } from "./router";

// DrStack is a single-page marketing site — every nav/footer link is a same-page #anchor, so the
// only route is "/". The minimal router scaffold is retained for any future public pages.
export function App() {
  return (
    <RouterProvider>
      <Nav />
      <main>
        <Home />
      </main>
      <Footer />
    </RouterProvider>
  );
}
